import style from './DefaultLayout.module.scss';
import className from 'classnames/bind';
import {useContext, useState} from "react";
import {Drawer} from 'antd';
import {Image, FontAwesomeIcon} from "~/components";
import {AppContext} from "~/context/AppProvider";
import images from "../../assets/images";
import Sidebar from "../Sidebar";
import {LoginAsBanner} from "../LoginAs";

const cn = className.bind(style);

function DefaultLayout({children})
{
	const {isMobile} = useContext(AppContext);

	const [openDrawer, setOpenDrawer] = useState(false);

	const closeDrawer = () => setOpenDrawer(false);

	return (
		<div className={cn('wrapper')}>
			{/* Sidebar cố định bên trái (desktop / tablet) */}
			{!isMobile && (
				<aside className={cn('sider')}>
					<Sidebar />
				</aside>
			)}

			{/* Sidebar dạng drawer trên mobile */}
			{isMobile && (
				<Drawer
					placement="left"
					width={280}
					open={openDrawer}
					onClose={closeDrawer}
					closable={false}
					styles={{body: {padding: 0}}}
				>
					<Sidebar onNavigate={closeDrawer} />
				</Drawer>
			)}

			{/* Nội dung bên phải */}
			<main className={cn('main')}>
				{isMobile && (
					<div className={cn('topbar')}>
						<button className={cn('hamburger')} onClick={() => setOpenDrawer(true)}>
							<FontAwesomeIcon icon="fa-light fa-bars" />
						</button>
						<Image src={images.logo} alt="Omni SEO" className={cn('topbar-logo')} />
					</div>
				)}
				<div className={cn('content')}>
					<LoginAsBanner />
					{children}
				</div>
			</main>
		</div>
	);
}

export default DefaultLayout;
